<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header pb-0">
            <p class="mb-0 font-weight-bold">Registrar Nueva Tarea</p>
          </div>
          <div class="card-body">
            <form @submit.prevent="submitTask">
              <div class="row">
                <div class="col-md-6">
                  <label class="form-label mb-1">Tipo de Tarea</label>
                  <select class="form-select" v-model="task.task_type" >
                    <option :value="null" disabled>Seleccione tipo...</option>
                    <option v-for="type in taskTypes" :key="type.id" :value="type.id">{{ type.name }}</option>
                  </select>
                </div>

                <div class="col-md-6">
                  <label class="form-label mb-1">Sucursal / Branch</label>
                  <select class="form-select" v-model="task.branch" :disabled="userRole === 2">
                    <option :value="null" disabled>Seleccione sucursal...</option>
                    <option v-for="branch in branches" :key="branch.id" :value="branch.id">{{ branch.name }}</option>
                  </select>
                  <small v-if="userRole == 2" class="text-muted text-xxs">
                    * Bloqueado por sucursal asignada.
                  </small>
                </div>

                <div class="col-md-12 mt-3">
                  <label class="form-label font-weight-bold">Ubicación del Punto de Gestión (Opcional)</label>
                  <div id="task-map" class="border-radius-lg shadow-sm mb-2" style="height: 300px; z-index: 1;"></div>
                  <div class="row">
                    <div class="col-6">
                      <argon-input v-model="task.latitude" placeholder="Latitud" readonly size="sm" />
                    </div>
                    <div class="col-6">
                      <argon-input v-model="task.longitude" placeholder="Longitud" readonly size="sm" />
                    </div>
                  </div>
                </div>

                <div class="col-md-12 mt-3">
                  <label class="form-control-label">Descripción de la Tarea</label>
                  <argon-textarea v-model="task.description" :rows="3" placeholder="Detalle la gestión a realizar..." />
                </div>

                <div class="col-md-6 mt-3">
                  <label class="form-control-label">Fecha Límite</label>
                  <argon-input v-model="task.due_date" type="date" />
                </div>

                <div class="col-md-6 mt-3">
                  <label class="form-control-label">Prioridad</label>
                  <select class="form-select" v-model="task.priority">
                    <option value="Low">Baja</option>
                    <option value="Medium">Media</option>
                    <option value="High">Alta</option>
                  </select>
                </div>

                <hr class="horizontal dark my-4" />

                <div class="col-md-12">
                  <div class="form-check form-switch mb-3">
                    <input class="form-check-input" type="checkbox" id="assignTask" v-model="wantsToAssign" />
                    <label class="form-check-label font-weight-bold" for="assignTask">¿Desea asignarla a un usuario ahora?</label>
                  </div>
                </div>

                <div v-if="wantsToAssign" class="col-md-12 bg-light p-3 border-radius-lg">
                  <label class="form-label mb-1">Seleccionar Usuario Responsable</label>
                  <ArgonLookup :options="users" v-model="userSelected" track-by="id" display-key="full_name" />
                </div>
              </div>

              <argon-button type="submit" class="mt-4" color="info" fullWidth size="lg">
                Guardar y Registrar Tarea
              </argon-button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonTextarea from "@/components/ArgonTextarea.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonLookup from "@/components/ArgonLookup.vue";
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import axios from "axios";
import Swal from 'sweetalert2';
import L from 'leaflet';

const companyId = localStorage.getItem('companyId');
const DEFAULT_CENTER = [13.689, -89.187]; // Ajusta a tu ciudad por defecto

export default {
  name: "CreateTask",
  components: { ArgonInput, ArgonButton, ArgonTextarea, ArgonLookup },
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      submitted: false,
      wantsToAssign: false,
      map: null,
      marker: null,
      taskTypes: [],
      branches: [],
      users: [],
      userSelected: null,
      userRole:parseInt(localStorage.getItem('userLevel')),
      userBranchId:parseInt(localStorage.getItem('branchId')),
      task: {
        task_type: null,
        branch: null,
        description: '',
        due_date: '',
        priority: 'Medium',
        status: 'Pending',
        latitude: null,
        longitude: null
      },
      assignment: {
        user: null,
        task: null
      }
    };
  },
  validations() {
    return {
      task: {
        task_type: { required },
        branch: { required },
        description: { required }
      }
    };
  },
  watch: {
    userSelected(val) { this.assignment.user = val ? val.id : null; }
  },
  methods: {
    initializeMap() {
      this.map = L.map('task-map').setView(DEFAULT_CENTER, 13);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; OpenStreetMap'
      }).addTo(this.map);

      // Icono por defecto (Fix para Webpack/Vite)
      const icon = L.icon({
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        iconSize: [25, 41],
        iconAnchor: [12, 41]
      });

      this.marker = L.marker(DEFAULT_CENTER, { draggable: true, icon }).addTo(this.map);

      // Evento: Arrastrar marcador
      this.marker.on('dragend', () => {
        const position = this.marker.getLatLng();
        this.task.latitude = position.lat.toFixed(8);
        this.task.longitude = position.lng.toFixed(8);
      });

      // Evento: Click en mapa
      this.map.on('click', (e) => {
        this.marker.setLatLng(e.latlng);
        this.task.latitude = e.latlng.lat.toFixed(8);
        this.task.longitude = e.latlng.lng.toFixed(8);
      });
    },

    async fetchMasterData() {
      const token = localStorage.getItem("accessToken");
      const config = { headers: { 'Authorization': `Bearer ${token}` } };
      console.log(this.userBranchId,this.userRole )
      try {
        let branchesUrl = `${this.$store.state.apiURL}branches?company=${companyId}`;
        let usersUrl = `${this.$store.state.apiURL}users?company=${companyId}`;

        if (this.userRole == 2 && this.userBranchId && this.userBranchId !== 'null') {
          usersUrl += `&fk_branch_id=${this.userBranchId}`;
          this.task.branch = parseInt(this.userBranchId);
          this.task.branch =this.userBranchId
        }

        const [types, branches, users] = await Promise.all([
          axios.get(`${this.$store.state.apiURL}task_type`, config),
          axios.get(branchesUrl, config),
          axios.get(usersUrl, config)
        ]);

        this.taskTypes = types.data;
        this.branches = branches.data;
        if(this.userRole==2){
          this.branches= this.branches.filter(x=> x.id==this.userBranchId);
        }
        this.users = users.data;

      } catch (e) { console.error(e); }
    },

    async submitTask() {
      this.submitted = true;
      this.v$.$touch();
      if (this.v$.$invalid || (this.wantsToAssign && !this.assignment.user)) {
        Swal.fire('Atención', 'Complete los campos obligatorios.', 'warning');
        return;
      }

      const token = localStorage.getItem("accessToken");
      const config = { headers: { 'Authorization': `Bearer ${token}` } };

      try {
        const result = await axios.post(`${this.$store.state.apiURL}task`, this.task, config);
        if (this.wantsToAssign) {
          this.assignment.task = result.data.id;
          await axios.post(`${this.$store.state.apiURL}task_assignment`, this.assignment, config);
        }
        Swal.fire('Éxito', 'Tarea registrada correctamente.', 'success');
        this.$router.push('/tasks');
      } catch (err) {
        Swal.fire('Error', 'No se pudo guardar la tarea.', 'error');
      }
    }
  },
  mounted() {
    this.fetchMasterData();
    this.initializeMap();
  }
};
</script>

<style scoped>
/* Asegura que el mapa no se vea gris al cargar */
#task-map {
  border: 1px solid #dee2e6;
}
</style>